/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Bullet3Inputs */

const es_ab_bullet3 = /** @type {(inputs: Ab_Bullet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con patrón, sin patrón o experiencias compartidas`)
};

const gl_ab_bullet3 = /** @type {(inputs: Ab_Bullet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con patrón, sen patrón ou experiencias compartidas`)
};

const en_ab_bullet3 = /** @type {(inputs: Ab_Bullet3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With skipper, bareboat, or shared experiences`)
};

/**
* | output |
* | --- |
* | "With skipper, bareboat, or shared experiences" |
*
* @param {Ab_Bullet3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_bullet3 = /** @type {((inputs?: Ab_Bullet3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Bullet3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_bullet3(inputs)
	if (locale === "en") return en_ab_bullet3(inputs)
	return es_ab_bullet3(inputs)
});